function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _class;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/** @module others/renderSortMenu */

/* global rmlOpts */
import React from "react";
import { Menu, message } from "react-aiot";
import { i18n, IS_DARKMODE, hooks, textDots, getMediaDialogNextZIndex } from "../util";
import { observer, inject, Provider } from "mobx-react";
import { DashIcon, Modal } from "../components";
import FolderBox, { FolderBoxHeader } from "../components/FolderBox";
import { FolderSelector } from "../components/FolderSelector";
import { BasicStore, createUnorganizedNode } from "../store";
import { getSnapshot } from "mobx-state-tree";
import $ from "jquery";
var Item = Menu.Item,
    SubMenu = Menu.SubMenu,
    Divider = Menu.Divider,
    ItemGroup = Menu.ItemGroup;

if (process.env.PLUGIN_CTX === "pro") {
  /* onlypro:start */
  hooks.register("folder/children/order/name_asc", function (children, setChildren) {
    setChildren(children.sort(function (a, b) {
      return a.title.localeCompare(b.title);
    }));
  }).register("folder/children/order/name_desc", function (children, setChildren) {
    setChildren(children.sort(function (a, b) {
      return a.title.localeCompare(b.title) * -1;
    }));
  }).register("folder/children/order/id_asc folder/children/order/original", function (children, setChildren) {
    setChildren(children.sort(function (a, b) {
      return a.id > b.id ? 1 : b.id > a.id ? -1 : 0;
    }));
  }).register("folder/children/order/id_desc", function (children, setChildren) {
    setChildren(children.sort(function (a, b) {
      return a.id > b.id ? -1 : b.id > a.id ? 1 : 0;
    }));
  });
  /* onlypro:end */
}
/**
 * An element rendering sortables for the popup menu.
 *
 * @returns React.Element[]
 */


var createSortables = function createSortables(sortables, select, selectText) {
  return Object.keys(sortables).map(function (key) {
    return /*#__PURE__*/React.createElement(Item, {
      key: key
    }, sortables[key], " ", select === key && /*#__PURE__*/React.createElement("strong", null, "(", selectText, ")"));
  });
};
/**
 * Apply an order to a tree node object.
 *
 * @this AppTree
 */


function applyOrder(_x, _x2, _x3) {
  return _applyOrder2.apply(this, arguments);
}
/**
 * When clicking on a menu item in the order menu popup.
 *
 * @this AppTree
 */


function _applyOrder2() {
  _applyOrder2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(selected, key, automatically) {
    var hide;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(!rmlOpts.others.isPro && rmlOpts.others.showProHints)) {
              _context2.next = 4;
              break;
            }

            this.setState({
              showProFeature: "order-subfolders"
            });
            _context2.next = 8;
            break;

          case 4:
            hide = message.loading(i18n("sortLoadingText", {
              name: selected.title
            }));
            _context2.next = 7;
            return selected.applyChildrenOrder(key, automatically);

          case 7:
            hide();

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));
  return _applyOrder2.apply(this, arguments);
}

function handleClick(_x4) {
  return _handleClick.apply(this, arguments);
}
/**
 * Render the order menu.
 *
 * @type React.Element
 */


function _handleClick() {
  _handleClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref) {
    var key, keyPath, path, _this$props$store, selectedId, selected, _applyOrder;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            key = _ref.key, keyPath = _ref.keyPath;
            path = keyPath.reverse(), _this$props$store = this.props.store, selectedId = _this$props$store.selectedId, selected = _this$props$store.selected, _applyOrder = applyOrder.bind(this);

            if (path[0] === "manual") {
              this.setState({
                rearrangeBoxId: selectedId
              });
            } else if (path[0] === "applyOnce") {
              _applyOrder(selected, key);
            } else if (path[0] === "applyAutomatically") {
              _applyOrder(selected, key, true);
            } else if (key === "reset") {
              _applyOrder(selected, "original");
            } else if (key === "resetAutomatically") {
              _applyOrder(selected, "deactivate");
            } else if (key === "applyReindex") {
              _applyOrder(selected, "reindex");
            }

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));
  return _handleClick.apply(this, arguments);
}

export default function () {
  var store = this.props.store,
      selectedId = store.selectedId,
      selected = store.selected,
      sortables = store.treeSortables,
      isFolder = selectedId > 0;
  return isFolder ? /*#__PURE__*/React.createElement(Menu, {
    onClick: handleClick.bind(this),
    theme: IS_DARKMODE ? "dark" : "light"
  }, /*#__PURE__*/React.createElement(Item, {
    key: "manual"
  }, i18n("sortByManual", {
    name: textDots(selected.title)
  })), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(ItemGroup, {
    title: /*#__PURE__*/React.createElement("span", null, i18n("subfolders"), " (", textDots(selected.title), ")")
  }, !!selected.lastSubOrderBy && /*#__PURE__*/React.createElement(Item, {
    key: "reset"
  }, i18n("resetOrder")), !selected.subOrderAutomatically ? /*#__PURE__*/React.createElement(SubMenu, {
    key: "applyOnce",
    title: i18n("applyOrderOnce")
  }, sortables && createSortables(sortables, selected.lastSubOrderBy, i18n("last"))) : /*#__PURE__*/React.createElement(Item, {
    key: "resetAutomatically"
  }, i18n("deactivateOrderAutomatically")), /*#__PURE__*/React.createElement(SubMenu, {
    key: "applyAutomatically",
    title: i18n("applyOrderAutomatically")
  }, sortables && createSortables(sortables, selected.subOrderAutomatically && selected.lastSubOrderBy, i18n("latest"))), !!selected.lastSubOrderBy && /*#__PURE__*/React.createElement(Item, {
    key: "applyReindex"
  }, i18n("reindexOrder")))) : /*#__PURE__*/React.createElement("span", null);
}
/**
 * Show a rearrange box for the selected folder id.
 *
 * @property {int} id The id of the folder
 * @extends React.Component
 */

var RearrangeBox = (_dec = inject("store"), _dec(_class = observer(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(RearrangeBox, _React$Component);

  var _super = _createSuper(RearrangeBox);

  function RearrangeBox(_props) {
    var _this;

    _classCallCheck(this, RearrangeBox);

    _this = _super.call(this, _props);

    _this.handleSelect = function (parent) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          siblingStore = _assertThisInitialize.siblingStore,
          tree = $.extend(true, [], getSnapshot(parent ? parent.childNodes : _this.props.store.tree));

      tree.forEach(function (n) {
        return n.childNodes = [];
      });
      siblingStore.setTree(tree);
      var selected = siblingStore.selected;
      selected && selected.setter(function (n) {
        return n.selected = false;
      }); // Reset selection
    };

    _this.handleSave = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var store, id, _assertThisInitialize2, parentStore, siblingStore, oldItem, props, parentTo, newIndexRelative, newIndexA;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setState({
                loading: true
              });

              try {
                store = _this.props.store, id = _this.item.id, _assertThisInitialize2 = _assertThisInitialized(_this), parentStore = _assertThisInitialize2.parentStore, siblingStore = _assertThisInitialize2.siblingStore, oldItem = store.getTreeItemById(id), props = {
                  id: id,
                  oldIndex: oldItem.parentArray.indexOf(oldItem),
                  parentFromId: oldItem.parentId,
                  parentToId: parentStore.selected ? parentStore.selectedId : store.rootId,
                  nextId: siblingStore.selectedId || NaN,
                  doFinally: false
                }; // Get newIndex

                parentTo = store.getTreeItemById(props.parentToId), newIndexRelative = parentTo ? parentTo.childNodes : store.tree, newIndexA = newIndexRelative.filter(function (_ref3) {
                  var id = _ref3.id;
                  return id !== oldItem.id;
                }).map(function (_ref4, idx) {
                  var id = _ref4.id;
                  return id === props.nextId ? "" + idx : null;
                }).filter(Boolean).map(function (i) {
                  return +i;
                });
                props.newIndex = !isNaN(props.nextId) && newIndexA.length ? newIndexA[0] : newIndexRelative.length; // Do the sorting

                _this.props.onSort(props);
              } finally {
                _this.setState({
                  loading: false
                });
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    _this.handleNodeInit = function (itemId) {
      var _this$item = _this.item = _this.parentStore.getTreeItemById(itemId, false),
          nextSibling = _this$item.nextSibling,
          parentArray = _this$item.parentArray,
          id = nextSibling ? nextSibling.id : undefined;

      _this.setState({
        nextId: id
      }, function () {
        var tree = $.extend(true, [], getSnapshot(parentArray)),
            _assertThisInitialize3 = _assertThisInitialized(_this),
            siblingStore = _assertThisInitialize3.siblingStore,
            parentStore = _assertThisInitialize3.parentStore;

        tree.forEach(function (n) {
          return n.childNodes = [];
        });
        siblingStore.setTree(tree);
        parentStore.getTreeItemById(_this.item.id).setter(function (n) {
          return n.$visible = false;
        });
        siblingStore.getTreeItemById(_this.item.id).setter(function (n) {
          return n.$visible = false;
        });
        id !== undefined && siblingStore.getTreeItemById(id).setter(function (n) {
          return n.selected = true;
        });
      });
    };

    _this.state = {
      nextId: undefined,
      loading: false
    };
    _this.parentStore = BasicStore.create({
      staticTree: [createUnorganizedNode()]
    }); // Create sibling store

    _this.siblingStore = BasicStore.create({
      staticTree: [createUnorganizedNode()]
    });
    return _this;
  }
  /**
   * Create the sibling tree.
   */


  _createClass(RearrangeBox, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var modalContent, title;
      var selected = this.props.id && this.props.store.getTreeItemById(this.props.id, false);

      if (selected) {
        var selectedId = selected.parentId > 0 ? selected.parentId : "";
        title = /*#__PURE__*/React.createElement(FolderBoxHeader, {
          icon: /*#__PURE__*/React.createElement(DashIcon, {
            name: "sort"
          }),
          folder: selected
        });
        modalContent = /*#__PURE__*/React.createElement(FolderBox, {
          folder: selected,
          header: false
        }, /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h3", null, i18n("parent")), /*#__PURE__*/React.createElement(Provider, {
          tree: this.parentStore
        }, /*#__PURE__*/React.createElement(FolderSelector, {
          selected: selectedId,
          nullable: true,
          disabled: "4",
          onSelect: this.handleSelect,
          onNodeInit: function onNodeInit() {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return _this2.handleNodeInit.apply(_this2, [_this2.props.id].concat(args));
          }
        })), /*#__PURE__*/React.createElement("h3", null, i18n("beforeThisNode")), /*#__PURE__*/React.createElement(Provider, {
          tree: this.siblingStore
        }, /*#__PURE__*/React.createElement(FolderSelector, {
          fetch: false,
          nullable: true,
          disabled: "4",
          ignoreChildNodes: true
        })), /*#__PURE__*/React.createElement("p", {
          className: "description"
        }, i18n("beforeThisNodeInfo"))));
      }

      return /*#__PURE__*/React.createElement(Modal, {
        visible: !!modalContent,
        title: title,
        onOk: this.handleSave,
        onCancel: this.props.onClose,
        cancelText: i18n("cancel"),
        okText: i18n("save"),
        zIndex: getMediaDialogNextZIndex(),
        confirmLoading: this.state.loading
      }, modalContent);
    }
  }]);

  return RearrangeBox;
}(React.Component)) || _class) || _class);
export { RearrangeBox };